module.exports = __webpack_public_path__ + "ec6d38920ca19d995576a9bf10069b56.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/mask-feathers.png
// module id = 2366
// module chunks = 0